<template>
  <DataTable
    class="tableHeaderStyle"
    :value="inventory"
    stripedRows
    tableStyle="min-width: 50rem"
    ref="dt"
    :exportFilename="exportFileName"
  >
    <!-- <Column sortable field="index" header="#" /> -->
    <Column sortable field="dateReceived" header="Date Received" />

    <Column sortable field="userId" header="Recorded By" />
    <Column field="vesselId" header="Vessel ID" />
    <Column sortable field="productId" header="Product">
      <template #body="inventory">
        <ProductType :type="inventory.data.depotProductName" />
      </template>
    </Column>
    <Column sortable field="quantity" header="Quantity">
      <template #body="inventory">
        {{ formatNumber(inventory.data.quantity) }}
      </template>
    </Column>

    <!-- <template #empty> No Inventory has been recorded in this depot </template> -->
    <template #empty>
      <div class="pt-4 text-center">
        <EmptyList :type="'Inventory'" />
      </div>
    </template>
  </DataTable>

  <Pagination :paginationData="pagination" :handler="handlePagination" />
</template>

<script>
//utils
import { formatNumber } from "@/utils/formatter";

//libraries
import Column from "primevue/column";
import DataTable from "primevue/datatable";

//components
import ProductType from "@/components/UI/ProductTypes";
import Pagination from "@/components/UI/Pagination/index.vue";
import EmptyList from "@/components/Empty/index.vue";

export default {
  name: "DepotInventory",
  props: [
    "depotId",
    "inventory",
    "exportFileName",
    "pagination",
    "handlePagination",
  ],
  components: {
    Column,
    DataTable,
    Pagination,
    ProductType,
    EmptyList,
  },
  data() {
    return {
      formatNumber: formatNumber,
    };
  },
  mounted() {},
  methods: {
    exportTable() {
      this.$refs.dt.exportCSV();
    },
  },
};
</script>

<style></style>
